import { z, isoZ } from 'my-zod'
import { LanguageEnum } from '../../internal'

export const HelmetSizeOptions = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'] as const
const HelmetSizeEnum = z.enum(['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'])
export type HelmetSize = z.infer<typeof HelmetSizeEnum>

export const customersModel = z.object({
  id: z.string().uuid(),
  shortId: z.string().nullish(),
  ssoEmail: z.string().nonempty().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  gender: z.string().nullish(),
  genderAccuracy: z.number().nullish(),
  helmetSize: HelmetSizeEnum.nullable(),
  notes: z.string().nullable(),
  email: z.string().nullable(),
  secondaryEmail: z.string().nullable(),
  addressLine1: z.string().nullable(),
  addressLine2: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  postalCode: z.string().max(15).nullable(),
  country: z.string().nullable(),
  primaryPhone: z.string().nullable(),
  DOB: isoZ.date().nullable(),
  hasMotorcycleLicense: z.boolean().nullable(),
  marketingOptIn: z.boolean().nullable(),
  driverLicenseNumber: z.string().max(30).nullable(),
  driverLicenseState: z.string().nullish(),
  driverLicenseCountry: z.string().nullish(),
  driverLicenseExpirationDate: isoZ.date().nullish(),
  market: z.string().nullish().describe('Preferred riding area for member, chosen initially during sign-up.'),
  referringPartnerId: z.string().nullable(),
  createdDate: isoZ.instant().nullable(),
  lastModifiedDate: isoZ.instant().nullable(),
  isSsoEmailVerified: z.boolean().optional(),
  preferredLanguage: LanguageEnum.nullable().optional(),
  lastAgreedSelectTermsDate: isoZ.instant().nullish()
})

export type customersModel = z.infer<typeof customersModel>
